import PropTypes from 'prop-types';
import { Icon } from '@eti/components';
import { css, etiColors } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { resetButtonStyles } from '../../utils/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const buttonStyles = css`
  ${resetButtonStyles}; /* stylelint-disable-next-line */
  color: white;
  cursor: pointer;
  font-size: 0.85rem;
  line-height: 1;
  position: absolute;
  right: 0.375rem;
  top: 0.375rem;
  z-index: 10;

  [dir='rtl'] & {
    left: 0.375rem;
    right: auto;
  }

  @media (min-width: 48em) {
    right: 0.5rem;
    top: 0.5rem;

    [dir='rtl'] & {
      left: 0.5rem;
      right: auto;
    }
  }

  & svg {
    fill: ${etiColors.white};
    margin-bottom: -2px;
  }

  &:hover svg {
    fill: ${etiColors.grayScale[4]};
  }
`;
const iconStyles = css`
  height: 0.85rem;
  user-select: none;
  width: 0.85rem;
`;
const SeatMapCloseIcon = _ref => {
  let {
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  const closeLabel = t('Product.SeatMap.Header.CloseButton');
  return /*#__PURE__*/_jsxs("button", {
    className: buttonStyles,
    "data-testid": "seatMap-closeIcon-button",
    onClick: onClose,
    type: "button",
    children: [closeLabel, " ", /*#__PURE__*/_jsx(Icon, {
      className: iconStyles,
      id: "close-menu"
    })]
  });
};
SeatMapCloseIcon.propTypes = {
  onClose: PropTypes.func
};
export default SeatMapCloseIcon;
//# sourceMappingURL=SeatMapCloseIcon.js.map